import React from 'react';
import _ from 'lodash';
import c from 'classnames';
import { THEME } from '@miotech/picasso';

import './Avatar.global.styl';

// those colors are private only to Avatar
const backgroundColors = [
  '#4C7863',
  '#12918B',
  '#AF6D40',
  '#A5801D',
  '#905959',
  '#6F5BA2',
  '#367495',
];

function getInitialsFromName(name = '') {
  const result = [];

  if (typeof name === 'string') {
    const parts = name.trim().split(' ');
    const { length } = parts;

    if (length > 0) {
      result.push(parts[0][0]);
    }
    if (length > 1) {
      result.push(parts[length - 1][0]);
    }
  }

  return result.join('');
}

function getBackgroundColorFromName(name: string) {
  if (!name) {
    return THEME.third;
  }
  const hash = _.sum(name.split('').map(char => char.charCodeAt(0)));
  return backgroundColors[hash % backgroundColors.length];
}

interface Props {
  size: string;
  disabled: boolean;
  name: string;
  className: string;
}

function Avatar({ size, disabled, name, className }: Props) {
  return (
    <div
      className={c(['mio-avatar', { disabled: disabled }, size, className])}
      style={{
        backgroundColor: getBackgroundColorFromName(name),
      }}
    >
      {getInitialsFromName(name)}
    </div>
  );
}

Avatar.defaultProps = {
  size: 'medium',
  disabled: false,
  name: '',
  className: '',
} as Partial<Props>;

export default Avatar;
